import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useI18n, LANGS } from "@/context/I18nContext";

// Gold language dropdown (flags + native names) used on landing and auth screens.
export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} className={`relative inline-block ${className}`} data-testid="lang-toggle">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-toggle-btn"
        className="flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-semibold bg-black/50 border border-[var(--rc-border)] text-[var(--rc-silver)]"
      >
        <span>{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-2xl bg-[var(--rc-bg)] border border-[var(--rc-border)] shadow-xl overflow-hidden z-50" data-testid="lang-toggle-menu">
          {LANGS.map((L) => (
            <button
              key={L.code}
              type="button"
              onClick={() => { setLang(L.code); setOpen(false); }}
              data-testid={`lang-toggle-${L.code}`}
              className={`w-full flex items-center gap-2.5 px-3.5 py-2.5 text-sm text-left transition-colors ${lang === L.code ? "bg-[var(--rc-gold)]/15 text-[var(--rc-gold)]" : "text-[var(--rc-text)] hover:bg-[var(--rc-surface)]"}`}
            >
              <span className="text-base">{L.flag}</span> {L.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
